// Bootstrap
require('./bootstrap');

// Slick
require('slick-carousel');
require('slick-lightbox');

require('jquery.easing');
require('./jquery.isonscreen.min');

/* FontAwesome */
import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';

fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);

let resizeTimer;
$(window).on('load resize', function () {

    // console.log('trigger');
    equalHeights();
    setTimeout(equalHeights(), 1000);

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        equalHeights();
        // console.log('second run');
    }, 1000);
});

function countUp(facts_scrolled) {
    $('.countUp').each(function () {
        if (facts_scrolled[$(this).attr('data-countid')] === undefined && $(this).isOnScreen()) {

            let $this = $(this),
                countTo = $this.attr('data-count');

            $({countNum: 0}).animate({
                    countNum: countTo
                },
                {
                    duration: Math.floor(Math.random() * 5000) + 3000,
                    easing: 'easeOutQuad',
                    step: function () {
                        $this.text(Math.floor(this.countNum));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    },
                    complete: function () {
                        $this.text(Math.floor(this.countNum));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    }
                });
        }

    });
}

let facts_scrolled = [];

$(window).on('scroll', function (e) {
    countUp(facts_scrolled);
});

$(window).on('load', function (e) {
    countUp(facts_scrolled);
});

$(document).bind('mouseup touchend', function(e) {
    let container = $("div.sticky-header--desktop-navigation ul.navigation--main");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('div.sticky-header--desktop-navigation ul.navigation--main li.parentnav').removeClass('hover');
    }
});

$(document).bind('mouseup touchend', function(e) {
    let container = $("a.card-image");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('a.card-image').removeClass('hover');
    }
});

$(document).ready(function() {

    $('.loading-page').show();
    countUp(facts_scrolled);

    $('a.card-image').on("touchstart", function (e) {
        'use strict'; //satisfy code inspectors
        let link = $(this); //preselect the link
        if (link.hasClass('hover')) {
            return true;
        }
        else {
            link.addClass('hover');
            $('a.card-image').not(this).removeClass('hover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    $('.btn-search').on('click', function(e) {
        e.preventDefault();
        if($('#mobile-search--container').hasClass('active')) {
            $('#mobile-search--container').removeClass('active');
            $('.btn-search').removeClass('active');
            $('body').removeClass('nav-overflow');
        } else {
            $('#mobile-search--container').addClass('active');
            $('.btn-search').addClass('active');
            $('body').removeClass('nav-overflow');

            $('#mobile-nav--container').removeClass('active');
            $('.menu-open').addClass('show');
            $('.menu-open').removeClass('hide');
            $('.menu-close').removeClass('show');
            $('.menu-close').addClass('hide');
            $('.btn-nav').removeClass('active');
        }
    });

    $('.btn-nav').on('click', function(e) {
        e.preventDefault();
        if($('#mobile-nav--container').hasClass('active')) {
            $('#mobile-nav--container').removeClass('active');
            $('.menu-open').addClass('show');
            $('.menu-open').removeClass('hide');
            $('.menu-close').removeClass('show');
            $('.menu-close').addClass('hide');
            $('.btn-nav').removeClass('active');
            $('body').removeClass('nav-overflow');
        } else {
            $('#mobile-nav--container').addClass('active');
            $('.menu-open').removeClass('show');
            $('.menu-open').addClass('hide');
            $('.menu-close').addClass('show');
            $('.menu-close').removeClass('hide');
            $('.btn-nav').addClass('active');
            $('body').addClass('nav-overflow');

            $('#mobile-search--container').removeClass('active');
            $('.btn-search').removeClass('active');
        }
    });

    /* Transitions Only After Page Load */
    $('body').removeClass('preload');

    $(window).resize(function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    $(window).on('orientationchange', function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    /* Slick Lightbox */
    $('.lightbox').slickLightbox({
        src: 'href',
        itemSelector: ' a',
        caption: 'caption'
    });


    $('[data-action=load]').click(function(e) {
        e.preventDefault();
        let el = $(this);
        axios.post(el.data('href'), {})
            .then((response) =>  {
                // console.log(response.data);
                $(el.data('target')).html(response.data);
            });


    });

});

function checkGrid() { // help function only
    let mode = '';
    if ($(window).width() >= 1200) {
        mode = 'XL';
    }
    else if ($(window).width() >= 992) {
        mode = 'LG';
    }
    else if ($(window).width() >= 768) {
        mode = 'MD';
    }
    else if ($(window).width() >= 576) {
        mode = 'SM';
    }
    else {
        mode = 'XS';
    }
    return mode;
}

function equalHeights() {
    let check = checkGrid();
    // console.log(check);

    if (check != 'XS') {

        // console.log($('.eqh-parent'));
        $('.eqh-parent').each(function () {
            let highestBox = 0;
            let highestTitle = 0;
            let highestText = 0;
            let highestBtn = 0;

            $(this).find('.eq-title-height').each(function () {
                if ($(this).outerHeight() > highestTitle) {
                    highestTitle = $(this).outerHeight();
                }
            });
            $(this).find('.eq-title-height').css({'height': highestTitle + "px"});

            $(this).find('.eq-text-height').each(function () {
                if ($(this).outerHeight() > highestText) {
                    highestText = $(this).outerHeight();
                }
            });
            $(this).find('.eq-text-height').css({'height': highestText + "px"});

            $(this).find('.eq-btn-height').each(function () {
                if ($(this).outerHeight() > highestBtn) {
                    highestBtn = $(this).outerHeight();
                }
            });
            $(this).find('.eq-btn-height').css({'height': highestBtn + "px"});


            $(this).find('.eq-box-height').each(function () {
                if ($(this).outerHeight() > highestTitle) {
                    highestBox = $(this).outerHeight();
                }
            });
            $(this).find('.eq-box-height').css({'height': highestBox + "px"});

        });
    }
}



// WEBPACK FOOTER //
// ./resources/js/frontend.js